import { isEmpty, isNil } from 'lodash';

// Default values should be coming from Contentful settings in the future
export const seoDefault = {
  title: 'Carma | The easy way to buy used cars in Australia',
  description: 'Carma | The easy way to buy used cars in Australia',
  socialImage: '',
};

export const seoDefault404 = {
  title: '404 Page Not Found | Carma',
  description: 'Whoops, looks like this page is missing',
  socialImage: '',
};

export const seoDefaultError = {
  title: 'Carma | Something went wrong',
  description: 'Oops, looks like something went wrong',
  socialImage: '',
};

export const defaultIfEmpty = (value: string | undefined, defaultValue: string) =>
  isNil(value) || isEmpty(value) ? defaultValue : value;
